import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { styles } from '../org-serviceline/org-servicelines.styles';
import { Box, Flex, Text } from '@chakra-ui/react';
export const DashboardSelectionSubNav = ({ activeDashboardOptions, activeDashboardName, handleDashboardSelection, ...props })=>{
    const classes = styles();
    return /*#__PURE__*/ _jsx(Box, {
        sx: classes['.popoverInsightsBox'],
        children: /*#__PURE__*/ _jsx(Flex, {
            sx: classes['.popoverHeader'],
            flexDirection: "column",
            children: activeDashboardOptions.dashboards.map((dashboard)=>{
                const { dashboardName, dashboardResource } = dashboard;
                return /*#__PURE__*/ _jsx(Flex, {
                    sx: classes['.switchItem'],
                    onClick: ()=>{
                        handleDashboardSelection(dashboardName, dashboardResource);
                    },
                    className: `hoverCursor ${activeDashboardName === dashboardName.split(' ')[0].toLowerCase() ? 'selectedItem' : ''}`,
                    children: /*#__PURE__*/ _jsx(Text, {
                        children: dashboardName
                    })
                }, dashboardName);
            })
        }, activeDashboardOptions.name + 'header')
    });
};
